export default function formatMessageContentRenderText (text) {
    return {
        text
    }
}
